import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { MdEmail } from "react-icons/md";
import { FaPhoneVolume } from "react-icons/fa6";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhoneVolume } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

import "./ContactForm.css";
import WhiteButton from "../../common_components/common_button/WhiteButton";
import Succes_lottie from "../../animation/succes_lottie/Succes_lottie";
import Login_Succes_Lottie from "./../../animation/login_succes_lottie/Login_Succes_Lottie";
import { useNavigate } from "react-router-dom";
import { CreateContact_Us } from "../../../features/admin/contactus/contact/Slice";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { AllAppSetup } from "../../../features/admin/common/Slice";

function ContactForm() {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  const all_app_setup = useSelector((state) => state?.common?.all_app_setup);

  useEffect(() => {
    dispatch(AllAppSetup());
  }, [dispatch]);

  const [slideState, setSlideState] = useState("");

  const onSubmit = async (data) => {
    try {
      const res = await dispatch(CreateContact_Us(data)).unwrap();

      if (res?.success) {
        setSlideState("show");
        reset();

        setTimeout(() => {
          navigate("/home");
        }, 2000);
      }
    } catch (error) {
      console.log("Contact error:", error);
    }
  };

  return (
    <section className="contact-section container">
      <div className="contact-container">
        {/* LEFT FORM */}
        <div className="contact-left">
          <div className="contact-card">
            <h4 className="title">Connect with</h4>
            <p className="subtitle">
              our team for reliable and timely support.
            </p>

            <Form onSubmit={handleSubmit(onSubmit)} className="contact-form">
              <Form.Group className="mb-3 mt-4">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="eg. sarah jamdar"
                  className="rounded-pill"
                  // ✅ Prevent typing numbers & symbols
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                  }}
                  {...register("name", {
                    required: "Name is required",

                    maxLength: {
                      value: 100,
                      message: "Name cannot exceed 100 Characters"
                    },

                    // ✅ Validation (extra safety)
                    pattern: {
                      value: /^[A-Za-z\s]+$/,
                      message: "Only alphabets are allowed",
                    },
                  })}
                />

                {errors?.name && (
                  <Form.Text className="text-danger">
                    {errors?.name?.message}
                  </Form.Text>
                )}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="text" // ✅ use text for full control
                  placeholder="eg. sarahjamdar@example.com"
                  className="custom-input"
                  // ✅ Restrict invalid characters while typing
                  onInput={(e) => {
                    let value = e.target.value;

                    // remove spaces
                    value = value.replace(/\s/g, "");

                    // allow only valid email characters
                    value = value.replace(/[^a-zA-Z0-9@._-]/g, "");

                    // prevent multiple @
                    const parts = value.split("@");
                    if (parts.length > 2) {
                      value = parts[0] + "@" + parts.slice(1).join("");
                    }

                    e.target.value = value.toLowerCase();
                  }}
                  {...register("email", {
                    required: "Email is required",

                    pattern: {
                      value: /^[a-zA-Z0-9]+([._-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/,
                      message: "Enter a valid email address",
                    },

                    validate: (value) => {
                      if (value.startsWith(".") || value.endsWith(".")) {
                        return "Email cannot start or end with dot";
                      }
                      if (value.includes("..")) {
                        return "No consecutive dots allowed";
                      }
                      if (!value.includes("@")) {
                        return "Email must contain @";
                      }
                      return true;
                    },
                  })}
                />

                {errors.email && (
                  <small className="text-danger">{errors.email.message}</small>
                )}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Subject </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="How can we help you?"
                  className="custom-input"
                  {...register("subject", {
                    required: "Subject is required",
                    maxLength: {
                      value: 100,
                      message: "Subject cannot exceed 100 characters",
                    },
                  })}
                />
                {errors.subject && (
                  <small className="text-danger">
                    {errors.subject.message}
                  </small>
                )}
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  placeholder="Tell us about your inquiry..."
                  className="custom-input textarea-form"
                  {...register("message", {
                    required: "Message is required",
                    maxLength: {
                      value: 300,
                      message: "Message cannot exceed 300 characters",
                    },
                  })}
                />
                {errors.message && (
                  <small className="text-danger">
                    {errors.message.message}
                  </small>
                )}
              </Form.Group>

              <div className="btn-wrapper">
                <WhiteButton
                  type="submit"
                  className="w-btn"
                  title={"Send Message"}
                  bg="#010E1E"
                  color="#F35F37"
                  hoverBg="#010E1E"
                  hoverColor="#F35F37"
                />

                <div
                  className={`slide-left ${slideState}`}
                  // onClick={handleClose}
                >
                  <Login_Succes_Lottie />
                  <div className="inner-right-slider">
                    <h4>Inquiry Submitted Successfully</h4>
                    <p>
                      Thank you for contacting us. We have received your inquiry
                      & our team is reviewing it. We’ll get back to you shortly.
                    </p>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>

        {/* RIGHT INFO */}
        <div className="contact-right">
          <div className="info-section">
            <h5>Contact us</h5>
            <p className="info-sub">For Quick Assistance.</p>
            <hr />

            <div className="info-item">
              <div className="icon-circle">
                <FontAwesomeIcon className="c-icon" icon={faEnvelope} />
              </div>
              <div>
                <small>Email:</small>
                <div className="fw-bold">{all_app_setup?.[0]?.email}</div>
              </div>
            </div>

            <div className="info-item">
              <div className="icon-circle">
                <FontAwesomeIcon className="c-icon" icon={faPhoneVolume} />
              </div>
              <div>
                <small>Phone:</small>
                <div className="fw-bold">
                  +91 {all_app_setup?.[0]?.contact_no}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactForm;
